// The community: the ways to take part, from a signature to a published workflow.
import { ArrowUpRight, Megaphone, PencilLine, Scales, Signature, TreeStructure, UsersThree } from "@phosphor-icons/react";
import { Link } from "react-router";

import { CONTACT_EMAIL } from "../content/contact";
import { useTitle } from "../ui/hooks";
import { PageHero } from "../ui/Section";

const WAYS = [
  { Icon: Signature, title: "Sign the Charter", body: "The simplest thing, and it counts: every name makes the bar heavier for AI companies to ignore.", to: "/charter#sign", cta: "Sign" },
  { Icon: TreeStructure, title: "Publish a workflow", body: "Your team has automated something well. Share it as a portable workflow, with your name on it, so others start from your lessons.", to: "/charter?interest=publish#sign", cta: "Tell us about it" },
  { Icon: Scales, title: "Argue with the Danger Scale", body: "Is reading email really level 1? Should a public pull request be outward? Propose changes and new actions.", to: "/tools/danger-scale", cta: "Read the scale" },
  { Icon: PencilLine, title: "Write with us", body: "Practitioners, lawyers, researchers, people who lost work to automation: the blog wants your view.", to: "/charter?interest=contribute#sign", cta: "Offer a piece" },
  { Icon: UsersThree, title: "Bring it to work", body: "Use the Learn guides and the vendor questions in your next AI rollout, and tell us what was missing.", to: "/learn", cta: "Open the guides" },
  { Icon: Megaphone, title: "Ask your representatives", body: "Price transparency, independent oversight and portable automations are policy questions. Write to the people who make policy.", to: "/blog/marsellus-wallaces-briefcase", cta: "Why it matters" },
];

export function Community() {
  useTitle("Community");
  return (
    <>
      <PageHero kicker="§ Community" title={<>All hands. Here's where yours go.</>}>
        OpenCloudSecurity is only as strong as the number of people holding the line with it. Pick one thing below; it is more than most people will do this year.
      </PageHero>
      <section className="wrap grid gap-4 py-14 md:grid-cols-2 lg:grid-cols-3">
        {WAYS.map((w) => (
          <Link key={w.title} to={w.to} className="card group flex flex-col p-6 transition-transform hover:-translate-y-1 sm:p-7">
            <w.Icon weight="duotone" className="h-9 w-9" aria-hidden />
            <h2 className="mt-6 font-display text-2xl font-bold tracking-tight">{w.title}</h2>
            <p className="mt-2 flex-1 text-[15.5px] text-ink2">{w.body}</p>
            <span className="mt-5 inline-flex items-center gap-1 font-semibold group-hover:text-signal">
              {w.cta} <ArrowUpRight weight="bold" className="h-4 w-4" aria-hidden />
            </span>
          </Link>
        ))}
      </section>
      <section className="wrap">
        <p className="card p-6 text-[15.5px] text-ink2">
          Anything else, or a story we should hear? Write to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="link">
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>
    </>
  );
}
